import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import QuickFacts from '@nerdwallet/react-quick-facts';
import styles from "../marketplace-product-card.module.css";
var ProductCardDrivers = function ProductCardDrivers(_ref) {
  var analytics = _ref.analytics,
    className = _ref.className,
    drivers = _ref.drivers,
    enableAnalytics = _ref.enableAnalytics,
    wrapDrivers = _ref.wrapDrivers,
    horizontalMobileDrivers = _ref.horizontalMobileDrivers;
  useDeprecatedPropsWarning({
    component: 'ProductCardDrivers',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  if (_isEmpty(drivers)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, wrapDrivers ? /*#__PURE__*/React.createElement("div", {
    className: styles.wrappedDrivers
  }, drivers.map(function (driver) {
    return /*#__PURE__*/React.createElement(QuickFacts, {
      analytics: analytics,
      className: styles.wrappedDriver,
      enableAnalytics: enableAnalytics,
      key: driver.id,
      quickFacts: [driver]
    });
  })) : /*#__PURE__*/React.createElement(QuickFacts, {
    analytics: analytics,
    enableAnalytics: enableAnalytics,
    quickFacts: drivers,
    groupLabelAndValue: horizontalMobileDrivers
  }));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  ProductCardDrivers.propTypes = {
    analytics: QuickFacts.propTypes.analytics,
    className: PropTypes.string,
    drivers: PropTypes.arrayOf(PropTypes.shape(QuickFacts.PropTypes)),
    enableAnalytics: PropTypes.bool,
    wrapDrivers: PropTypes.bool,
    horizontalMobileDrivers: PropTypes.bool
  };
}
ProductCardDrivers.defaultProps = {
  analytics: {},
  drivers: [],
  wrapDrivers: false,
  horizontalMobileDrivers: false
};
export default ProductCardDrivers;